import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './AuthPages.css';

const SignupTypePage = () => {
  const navigate = useNavigate();

  // ✅ S3 base host from .env (React env must start with REACT_APP_)
  const ICONS_BASE = (process.env.REACT_APP_S3_ICONS_BASE || '').replace(/\/$/, '');

  // ✅ helper to build icons url
  const ico = (fileName) => {
    const url = `${ICONS_BASE}/${fileName}`;
    console.log('Generated URL:', url); // Debug log
    return url;
  };

  // ✅ Debug: Log the base URL on component mount
  useEffect(() => {
    console.log('IMAGE_BASE:', ICONS_BASE);
    console.log('Sample URL:', ico('logo-header.png'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="profile-page">
      <div className="profile-shell">
        {/* Top header */}
        <div className="profile-top">
          <div className="profile-brand">
            <img
              src={ico('login-logo.svg')}
              alt="Logo"
              className="profile-logo"
            />
            <div>
              <h1 className="profile-title">Choose Account Type</h1>
              <p className="profile-subtitle">
                Select how you want to use Quick Socials
              </p>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="profile-grid">
          {/* Individual */}
          <button
            type="button"
            className="profile-card-modern"
            onClick={() => navigate('/signup/individual')}
          >
            <div className="profile-card-head">
              <div className="profile-card-icon">
                <img src={ico('user-icon.svg')} alt="User Icon" />
              </div>

              <div className="profile-card-text">
                <h3>Individual User</h3>
                <p>Perfect for personal use and managing your own accounts</p>
              </div>
            </div>

            <ul className="profile-list">
              <li>Manage your own posts</li>
              <li>Schedule content</li>
              <li>Multi-platform support</li>
            </ul>

            <div className="profile-cta">Select Individual →</div>
          </button>

          {/* Organization */}
          <button
            type="button"
            className="profile-card-modern"
            onClick={() => navigate('/signup/organization')}
          >
            <div className="profile-card-head">
              <div className="profile-card-icon">
                <img src={ico('org-icon.svg')} alt="Organization Icon" />
              </div>

              <div className="profile-card-text">
                <h3>Organizational User</h3>
                <p>Ideal for agencies and businesses managing multiple clients</p>
              </div>
            </div>

            <ul className="profile-list">
              <li>Manage multiple clients</li>
              <li>Team collaboration</li>
              <li>Client-based scheduling</li>
            </ul>

            <div className="profile-cta">Select Organizational →</div>
          </button>
        </div>

        {/* Footer */}
        <div className="profile-footer">
          <p className="create-account">
            Already have an account?
            <Link to="/login"> Login</Link>
          </p>

          <Link to="/" className="back-home">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignupTypePage;
